export enum ExportTypeFormat {
	CSV = 0,
	XLSX = 1,
}